module.exports = __webpack_public_path__ + "static/media/bike.89987380.png";